export default __webpack_public_path__ + "static/silversettingwithdifferentmeasurements-0ced55dc5f1713562427fef4ae11416d.png";